
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonicalPath?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  noIndex?: boolean;
  schema?: Record<string, any>;
}

export const SEO: React.FC<SEOProps> = ({
  title = 'Keystle - Identity Management Solutions',
  description = 'Keystle provides identity management solutions for businesses and organizations',
  canonicalPath = '',
  keywords = 'identity management, IAM, CIAM, workforce identity, business identity, customer identity',
  ogImage = '/lovable-uploads/5b07bdfd-0e08-4844-a9b0-8951d2f90108.png',
  ogType = 'website',
  noIndex = false,
  schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Keystle",
    "url": "https://keystle.com",
    "logo": "https://keystle.com/lovable-uploads/5b07bdfd-0e08-4844-a9b0-8951d2f90108.png",
    "description": "Keystle provides identity management solutions for businesses and organizations"
  }
}) => {
  const siteUrl = 'https://keystle.com';
  const fullUrl = `${siteUrl}${canonicalPath}`;
  
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SEO;
